import React, { ReactNode } from "react";
import { Box } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { nbNO } from '@mui/x-data-grid';

interface StyledDataGridProps {
    rows: any[];
    columns: any[];
    loading?: boolean;
    onRowClick?: (row: any) => void;
    height?: number | string;
    pageSize?: number;
}

const StyledDataGrid: React.FC<StyledDataGridProps> = ({
                                                           rows,
                                                           columns,
                                                           loading = false,
                                                           onRowClick,
                                                           height = 600,
                                                           pageSize = 15
                                                       }) => {
    const [size, setSize] = React.useState(pageSize);

    return (
        <Box sx={{
            ml: 3,
            mt: 5,
            height,
            minWidth: "50rem",
            maxWidth: "60rem",
            "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#2f4874",
                color: "#fff",
                fontSize: 16,
            }
        }}>
            <DataGrid
                loading={loading}
                rows={rows}
                columns={columns}
                pageSize={size}
                onPageSizeChange={(newSize) => setSize(newSize)}
                rowsPerPageOptions={[15, 30, 45]}
                pagination
                disableSelectionOnClick
                disableColumnMenu
                rowHeight={50}
                autoHeight
                localeText={nbNO.components.MuiDataGrid.defaultProps.localeText}
                onRowClick={onRowClick}
                components={{
                    Toolbar: GridToolbar,
                }}
                sx={{
                    "& .MuiDataGrid-virtualScrollerRenderZone .MuiDataGrid-row": {
                        ":hover": { color: "#5177b8" },
                        cursor: "pointer",
                        "&:nth-of-type(2n)": {
                            backgroundColor: "rgba(234, 234, 234, .7)",
                        },
                    },
                    "& .MuiDataGrid-toolbarContainer": {
                        backgroundColor: "#2f4874",
                        borderBottom: "1px solid #fff",
                        p: 1,
                        "& .MuiButtonBase-root": {
                            color: "#fff",
                        },
                    },
                }}
            />
        </Box>
    );
};

export default StyledDataGrid;
